<div class="container" [ngClass]="{'mobileView': isMobile}">
    <img src="./assets/img/signlease.svg" alt="" >
    <div class="text">
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        <div class="remark">{{'THANK_YOU_PAGE.REMARK' | translate}}</div>
        <div>{{'THANK_YOU_PAGE.TITLE_1' | translate}} <br>
        {{'THANK_YOU_PAGE.TITLE_2' | translate}} </div>
    </div>
</div>
